import { FormattedMessage } from 'react-intl'

import { IconHeaderError } from 'components/Icons'
import { Card } from 'components/Layout'

import { CenterContent } from './CenterContent'

export const Unauthorized = () => (
	<Card>
		<IconHeaderError />
		<CenterContent>
			<h2>
				<FormattedMessage id='flow.unauthorized.title' defaultMessage='Link is invalid' />
			</h2>

			<p>
				<FormattedMessage
					id='flow.unauthorized.description'
					defaultMessage='Please use the link provided to you by your advisor. If the issue persists, please reach out to them.'
				/>
			</p>
		</CenterContent>
	</Card>
)
